module.exports = __webpack_public_path__ + "img/Clavijo.bf417163.jpg";